import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Register Service Worker for PWA
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('VNFAM PWA: ServiceWorker registered with scope:', registration.scope);
      })
      .catch((error) => {
        console.warn('VNFAM PWA: ServiceWorker registration failed:', error);
      });
  });
}

// Listen for PWA install prompt
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later
  (window as any).deferredPrompt = e;
  window.dispatchEvent(new Event('pwa-installable'));
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
